import { useEffect, useRef } from 'react'

export default function useInterval<T extends () => unknown>(
  callback: T,
  delay: number,
) {
  const savedCallback = useRef<T | undefined>(undefined)

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current?.()
    }

    const id = setInterval(tick, delay)
    return () => clearInterval(id)
  }, [delay])
}
